import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import "./Cart.module.scss";
import { CaretDown } from "phosphor-react";
import CartSection from "./CartSection";
import CartBet from "./CartBet";
import CartBetScroller from "./CartBetScroller";
import { AmountChooser } from "../amountchooser/AmountChooser";
import { emitIntent } from "../../../../newDesign/utils/emitIntent";
// import { AmountChooser, realCurrencyFormatter } from "../games/concurso/AmountChooser";

const Cart = ({ bets = [], maxNumberSize=2, keepOpenWhenEmpty = true, totalAmount, onFinishClick, onRemoveClick, onClearClick, disableFinishButton, messages = {}, customOpenerTitle, amountChooser = {}, hideBetsSection, forceOpened = false, hideTotalAmount = false, classNames = {}, labels = {}}) => {
  const [isCartOpen, setIsCartOpen] = useState(forceOpened || false);
  const [cartTop, setCartTop] = useState(10000);
  
  const [footerHeight, setFooterHeight] = useState(100);
  
  const betCount = bets ? (bets.reduce((acc, cur) => cur.amount + acc, 0)) : amountChooser.currentAmount;
  const cartOpenerRef = useRef(null);

  useEffect(() => {
    function handleMessage(message){
      if(message.data && message.data.type && message.data.type === "scroll" && message.data.data) {
        const data = message.data.data;
        adjustPosition(data.scrollY, data.pageHeight, data.footerHeight, data.scrollHeight, data.headerHeight);
      }
    }

    window.addEventListener("message", handleMessage, { passive: true });
    window.addEventListener("resize", handleMessage, { passive: true });

    setTimeout(() => adjustPosition(0, 3000), 250);
    emitIntent("update_scroll_info", {});

    return () => {
      window.removeEventListener("message", handleMessage);
      window.removeEventListener("resize", handleMessage);
    }
  }, []);

  function adjustPosition(scrollY, pageHeight, footerHeight, scrollHeight, headerHeight) {
      const maxScrollHeight = scrollHeight - footerHeight;
      const cartBottom = scrollY + pageHeight;
      const navWrapperHeight = document.querySelector(".nav-wrapper") ? document.querySelector(".nav-wrapper").offsetHeight : 0;

      setCartTop(Math.min(cartBottom, maxScrollHeight) + 50 - navWrapperHeight - (headerHeight > 64 ? headerHeight - 64 : 0));
  }

  useEffect(() => {
    if(!bets.length && !keepOpenWhenEmpty && !forceOpened) setIsCartOpen(false);

  }, [bets, isCartOpen, keepOpenWhenEmpty]);

  const betElements = <CartBet
    onRemoveClick={(number) => {
      if(onRemoveClick) onRemoveClick(number);
      if(!bets.length && !keepOpenWhenEmpty && !forceOpened) setIsCartOpen(false);
    }}
    key={Math.random()}
    guesses={bets.map((bet) => {
      return {
        number: bet.number,
        displayText: (bet.label && bet.label.padStart(maxNumberSize, "0")) || String(bet.number).padStart(maxNumberSize, "0"),
        alternativeText: bet.alternativeText,
        amount: bet.amount,
      }
    })}
  />

  return (
    <div
      className={[
        "floatingCart__cartComponent",
        isCartOpen && (keepOpenWhenEmpty || betCount > 0) && "floatingCart__open",
        betCount > 0 && "floatingCart__notEmpty",
      ].filter(i=>i).join(" ")}
    >
      <div
        className={`floatingCart__cartBackground ${forceOpened ? "cleanBackground" : ""}`}
        onClick={() => !forceOpened && setIsCartOpen(false)}
      ></div>
      <div className={"floatingCart__cartWrapper"} style={{top: `${cartTop}px`}} >
        <div
          className={["floatingCart__cartOpener", classNames.header, isCartOpen && "floatingCart__openCart"].filter(i=>i).join(" ")}
          ref={cartOpenerRef}
          onClick={() => {
            if(betCount > 0 && !forceOpened) setIsCartOpen(() => !isCartOpen);
            else !forceOpened && setIsCartOpen(false);
          }}
        >
          <small className={"floatingCart__cartTitle"}>
            <strong>
              { customOpenerTitle || `${betCount} apostas - ${totalAmount}` }
            </strong>
          </small>
          { !forceOpened && <div className={"floatingCart__circleIcon"}>
            <CaretDown size={14} weight="bold"></CaretDown>
          </div> }
        </div>

        <div className={"floatingCart__cartContent"}>
          {!hideBetsSection ? (
          <CartSection sectionName="Suas apostas" startsOpen>
            <CartBetScroller>{betElements}</CartBetScroller>
          </CartSection>)
          : null}

          {amountChooser.show ? (
            <CartSection sectionName={amountChooser.label} startsOpen classNames={{content: `floatingCart__amountChooserWrapper ${forceOpened && "tinyPadding"}`}}>
              <AmountChooser className={amountChooser.className} formatter={(val) => val} currentAmount={amountChooser.currentAmount || 0} onSetIncrement={amountChooser.onIncrement} onSetDecrement={amountChooser.onDecrement} onManualChange={amountChooser.onManualChange} onManualLeave={amountChooser.onManualLeave}/>
            </CartSection>
          )
          : null
          }
        </div>

        {!!messages.afterContent && <p className="floatingCart__message">{messages.afterContent}</p>}

        <div className={`floatingCart__cartFooter ${classNames.footer || ""}`}>
          {!hideTotalAmount ? <div>
            <small>Total da aposta</small>
            <span className={"floatingCart__cartTotalValue"}>{totalAmount}</span>
          </div>
          : null }

          {!!messages.afterTotals && <p className="floatingCart__message">{messages.afterTotals}</p>}

          <div className={"floatingCart__buttonsWrapper"}>
            <button type="stroke" className="floatingCart__button_clear" onClick={() => {
              if(onClearClick) onClearClick();
            }}>Limpar carrinho</button>
            <button className={`floatingCart__button_finish ${classNames.finishButton}`} onClick={() => {
              if(onFinishClick) onFinishClick();
            }} disabled={disableFinishButton}>{labels.finishButton || "Finalizar agora"}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

Cart.propTypes = {
  theme: PropTypes.string,
  totalAmount: PropTypes.string.isRequired,
  classNames: PropTypes.shape({
    finishButton: PropTypes.string,
    footer: PropTypes.string,
    header: PropTypes.string,
  }),
  labels: PropTypes.shape({
    finishButton: PropTypes.string
  }),
  bets: PropTypes.arrayOf(PropTypes.shape({
    number: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    alternativeText: PropTypes.string
  })).isRequired,
  onFinishClick: PropTypes.func,
  onRemoveClick: PropTypes.func,
  onClearClick: PropTypes.func,
  disableFinishButton: PropTypes.boolean,
  showAmountChooser: PropTypes.boolean,
  amountChooser: PropTypes.shape({
    show: PropTypes.bool,
    currentAmount: PropTypes.number,
    onIncrement: PropTypes.func,
    onDecrement: PropTypes.func,
    onManualChange: PropTypes.func,
    onManualLeave: PropTypes.func,
    label: PropTypes.string,
    className: PropTypes.string,
  }),
  hideBetsSection: PropTypes.bool,
  messages: PropTypes.shape({
    afterContent: PropTypes.string,
    afterTotals: PropTypes.string,
  }),
  customOpenerTitle: PropTypes.string,
  keepOpenWhenEmpty: PropTypes.bool,
  forceOpened: PropTypes.bool,
  hideTotalAmount: PropTypes.bool,
};

export { Cart };



// WEBPACK FOOTER //
// ./src/rifa/components/layout/cart/Cart.jsx